import React, { FC } from 'react';
import { Table } from 'antd';
import { I18n } from 'react-redux-i18n';

import { formatDate } from '@utils/date';
import { IMovingHistoryTableProps } from './interfaces';

const MovingHistoryTable: FC<IMovingHistoryTableProps> = ({ data }) => {
  const columns = [
    {
      title: I18n.t('main.date'),
      dataIndex: 'date',
      key: 'date',
      render: (text: string) => formatDate(text, 'LLL'),
    },
    {
      title: I18n.t('admin.paymentsStats.moveFrom'),
      dataIndex: 'from',
      key: 'from',
    },
    {
      title: I18n.t('admin.paymentsStats.moveTo'),
      dataIndex: 'to',
      key: 'to',
    },
    {
      title: I18n.t('main.performer'),
      dataIndex: 'executor',
      key: 'executor',
    },
  ];

  return <Table columns={columns} dataSource={data} />;
};

export default MovingHistoryTable;
